import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import {BrowserRouter} from "react-router-dom";
import reportWebVitals from "./reportWebVitals";
import {AuthProvider} from "./context/AuthContext";
import {LanguageProvider} from "./context/LanguageContext";
import ScrollToTop from "./utils/ScrollToTop";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // </frontend/>
  <BrowserRouter basename="/">
    <AuthProvider>
      <LanguageProvider>
        <ScrollToTop>
          <App />
        </ScrollToTop>
      </LanguageProvider>
    </AuthProvider>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
